function hideAllQuestions() {
  const questions = document.querySelectorAll('.video-quiz-section__form');
  questions.forEach(element => {
    element.classList.add('is-hidden');
  });
}

function showInvitation() {
  document
    .querySelector('.video-quiz-section__invitation')
    .classList.toggle('is-hidden');

  document
    .querySelector('.video-quiz-section__questions')
    .classList.add('is-hidden');
}

function showNextQuestionForm(nextQuestionIndex) {
  document
    .querySelector(`.video-quiz-section__form--question-${nextQuestionIndex}`)
    .classList.toggle('is-hidden');
}

function isCorrectChoiceInForm(form) {
  const selector =
    '.video-quiz-section__option.video-quiz-section__option--correct.is-selected';
  return form.querySelector(selector) !== null;
}

function checkOptions(form) {
  form
    .querySelector('.video-quiz-section__option--correct')
    .classList.add('video-quiz-section__option--green');

  if (!isCorrectChoiceInForm(form)) {
    form
      .querySelector('.video-quiz-section__option.is-selected')
      .classList.add('video-quiz-section__option--red');
  }
}

function handleCheckCta(event) {
  const form = event.target.parentElement;

  checkOptions(form);

  // disable current answer options
  form.querySelectorAll('.video-quiz-section__option input').forEach(input => {
    input.disabled = true;
  });

  // hide check button
  event.target.classList.add('is-hidden');
  // show next button
  event.target.parentElement
    .querySelector('.video-quiz-section__cta-next')
    .classList.remove('is-hidden');
}

function handleNextCta(event) {
  const clicked = event.target;
  const nextQuestionIndex = clicked.dataset.nextQuestionIndex;
  const isLastQuestion = clicked.dataset.lastQuestion === 'true';

  hideAllQuestions();
  if (isLastQuestion) {
    showInvitation();
    return true;
  }

  showNextQuestionForm(nextQuestionIndex);
}

function handleRadioClicked(event) {
  const checkButton = event.target
    .closest('form')
    .querySelector('.video-quiz-section__cta-check');
  const options = document.querySelectorAll('.video-quiz-section__option');

  options.forEach(option => {
    option.classList.remove('is-selected');
  });

  event.target
    .closest('.video-quiz-section__option')
    .classList.add('is-selected');
  checkButton.removeAttribute('disabled');
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.video-quiz-section')) {
    const nextButtons = document.querySelectorAll(
      '.js-video-quiz-section__cta-next'
    );
    const checkButtons = document.querySelectorAll(
      '.js-video-quiz-section__cta-check'
    );
    const quizFormLabels = document.querySelectorAll(
      '.js-video-quiz-section__label'
    );
    const letsGoButton = document.querySelector(
      '.js-video-quiz-section__cta-lets-go'
    );

    [...nextButtons, ...checkButtons].forEach(buttons => {
      buttons.addEventListener('click', event => {
        event.preventDefault();
      });
    });

    checkButtons.forEach(nextButton => {
      nextButton.addEventListener('click', event => {
        handleCheckCta(event);
      });
    });

    nextButtons.forEach(nextButton => {
      nextButton.addEventListener('click', event => {
        handleNextCta(event);
      });
    });

    quizFormLabels.forEach(quizFormLabel => {
      quizFormLabel.addEventListener('click', event => {
        handleRadioClicked(event);
      });
    });

    letsGoButton.addEventListener('click', () => {
      showInvitation();
    });
  }

  if (window.renderMathInElement && renderMathInElement) {
    renderMathInElement(document.body, {
      // customised options
      // • auto-render specific keys, e.g.:
      delimiters: [
        { left: '$$', right: '$$', display: true },
        { left: '$', right: '$', display: false },
        { left: '\\(', right: '\\)', display: false },
        { left: '\\[', right: '\\]', display: true }
      ],
      // • rendering keys, e.g.:
      throwOnError: false
    });
  }
});
